import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

new Swiper(".interviews__swiper", {
    modules: [Navigation, Pagination],
    spaceBetween: 19,
    slidesPerView: "auto",
    pagination: {
        el: ".interviews__pagination",
        type: "progressbar",
    },
    navigation: {
        nextEl: ".interviews__navigation-button--next",
        prevEl: ".interviews__navigation-button--prev",
    },
    breakpoints: {
        0: {
            spaceBetween: 15,
        },
        576: {
            spaceBetween: 19,
        },
    },
});
